<template>
    <div>
        <div class="border">
            <v-row no-gutters>
                <v-col cols="12" lg="6">
                    <v-img :src="src" class="w-100"></v-img>
                </v-col>
                <v-col cols="12" lg="6">
                    <div class="w-100 h-100 pa-20 pa-md-30 py-lg-16 px-xl-60 d-flex align-center border-lg-start">
                        <div class="w-100">
                            <h6 class="color-point font-weight-medium page-text-lg pb-12 pb-lg-14 mb-14 mb-lg-16 w-100 border-bottom">
                                제품 문의
                            </h6>
                            <v-row class=" ma-n2 ma-md-n4 my-lg-n10 font-size-14 font-size-lg-16">
                                <v-col cols="12" sm="6" class="pa-2 pa-md-4 py-lg-10 d-flex" v-if="name">
                                    <p class="font-weight-bold color-grey-2c mr-6 mr-lg-16 w-40px">
                                        담당자
                                    </p>
                                    <p class="color-grey-51">
                                        {{name}}
                                    </p>
                                </v-col>
                                <v-col cols="12" sm="6" class="pa-2 pa-md-4 py-lg-10 d-flex" v-if="tel">
                                    <p class="font-weight-bold color-grey-2c mr-6 mr-lg-16 w-40px">
                                        연락처
                                    </p>
                                    <p class="color-grey-51">
                                        {{tel}}
                                    </p>
                                </v-col>
                                <v-col cols="12" sm="6" class="pa-2 pa-md-4 py-lg-10 d-flex" v-if="mail">
                                    <p class="font-weight-bold color-grey-2c mr-6 mr-lg-16 w-40px">
                                        이메일
                                    </p>
                                    <p class="color-grey-51">
                                        {{mail}}
                                    </p>
                                </v-col>
                                <v-col cols="12" sm="6" class="pa-2 pa-md-4 py-lg-10 d-flex" v-if="fax">
                                    <p class="font-weight-bold color-grey-2c mr-6 mr-lg-16 w-40px">
                                        FAX
                                    </p>
                                    <p class="color-grey-51">
                                        {{fax}}
                                    </p>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <a :href="link" target="_blank" class="detail-link-wrap d-block mt-20 mt-lg-36" :style="'background-image:url('+ linkBg +');'" v-if="link">
            <div class="detail-link color-white d-flex flex-column align-center justify-center text-center px-20 py-50 py-lg-84">
                <h3 class="tit font-weight-medium mb-14 mb-lg-28">
                    홈페이지에서 제품의 세부내용을 확인하세요
                </h3>
                <v-btn outlined color="rgba(255, 255, 255, 0.5)" class="min-w-140px min-w-lg-180px font-size-14 font-size-lg-16"><span class="color-white">바로가기</span></v-btn>
            </div>
        </a>
    </div>
</template>

<script>

export default{
    props : {
        src : {type :String, default : ""},
        name : {type :String, default : ""},
        tel : {type :String, default : ""},
        mail : {type :String, default : ""},
        fax : {type :String, default : ""},
        link : {type :String, default : ""},
        linkBg : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.detail-link-wrap{
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
}
@media (min-width:1200px){
    .detail-link-wrap{
        position: relative;
    }
    .detail-link-wrap::before{
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;
        background-color: rgba(71, 146, 14, 0.6);
        z-index: 0;
        opacity: 0;
        visibility: hidden;
        transition: 0.2s ease-out;
    }
    .detail-link-wrap::after{
        content: "";
        display: block;
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        top: 10px;
        left: 10px;
        position: absolute;
        border: 1px solid rgba(255, 255, 255, 0.5);
        z-index: 1;
        opacity: 0;
        visibility: hidden;
        transition: 0.2s ease-out;
    }
    .detail-link-wrap:hover::before,
    .detail-link-wrap:hover::after{
        opacity: 1;
        visibility: visible;
    }
    .detail-link{
        position: relative;
        z-index: 2;
    }
}

</style>